import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ParticipantService } from "../../services/participant.service";
import { ParticipantViewModel } from "../../models/participant-view-model";
import { CreateResult } from "../../models/create-result";
import { ToastrService } from 'ngx-toastr';
import { UserDataStoreService } from '../../services/user-data-store.service';
import { PermissionEnum } from '../../services/guards/permissions';
import { Select2OptionData } from 'ng-select2';
import { AuthenticationService } from "../../services/authentication.service";
import { ActivatedRoute } from "@angular/router";
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { SinkNodesUpdateViewModel } from '../../models/sink-nodes-update-view-model';
import { RaceSubscriber } from 'rxjs/internal/observable/race';
import { SettingsViewModel } from '../../models/settings-view-model';
import { _ParseAST } from '@angular/compiler';


@Component({
  selector: 'app-participant-view',
  templateUrl: './participant-view.component.html',
  styleUrls: ['./participant-view.component.scss']
})
export class ParticipantViewComponent implements OnInit {

  public participant: ParticipantViewModel;
  public createResult: CreateResult;
  public settings: SettingsViewModel;
  public canEdit: boolean;
  public canAdd: boolean;
  errorMessage: string;
  error: boolean;
  public danger: string;
  public raiseDanger: boolean;
  public warning: string;
  public raiseWarning: boolean;
  public disableFields: string;
  public adminUser: boolean;
  public csvData: any[] = [];
  public Status: string;
  public sinkNodesUpdate: SinkNodesUpdateViewModel[] = [];
  public sinkNodes: Select2OptionData[];
  public activateSerialNumber: boolean;

  public select2options: any = {
    multiple: false,
    width: '100%',
    allowClear: true
  };

  public totalCount: number;
  constructor(private _route: ActivatedRoute,
    private _participantService: ParticipantService,
    private _authenticationService: AuthenticationService,
    private _toastService: ToastrService,
    private _userDataStore: UserDataStoreService,
    private _ngxUiLoaderService: NgxUiLoaderService) {
    this.canEdit = this._userDataStore.hasRequiredPermissions([PermissionEnum.EditParticipantConfiguration], []);
    _route.params.subscribe(async params => {
      this.initParticipant(params.id);

    });


    if (this._userDataStore.currentUserValue.email == "Fransr@acs-sa.com" || this._userDataStore.currentUserValue.email == "admin@acs-sa.com") {
      this.adminUser = true;
    }
    else {
      this.adminUser = false;
    }
  }

  public async ngOnInit(): Promise<void> {

  }

  public async initParticipant(id: number): Promise<void> {
    this.participant = await this._participantService.GetParticipant(id);
    this.sinkNodes = (await this._participantService.GetAvailableSinkNodes(this.participant.id)).map((x) => {
      return { id: x.node, text: x.node }
    });
    if (!!this.participant?.aggregatorSinkNode) {
      this.sinkNodes.push({ id: this.participant.aggregatorSinkNode, text: this.participant.aggregatorSinkNode });
      if (!this.participant.isAggregator) {
        this.participant.isAggregator = true;
      }
    }

    this.settings = await this._participantService.GetSerialNumberField(id);

  }

  public validateMerchantNumber(): boolean {
    this.error = false;

    if (!!this.participant.aggregatorMerchant) {
      if (this.participant.aggregatorMerchant.length < 15 && this.participant.aggregatorMerchant !== '') {
        this.raiseDanger = true;
        this.danger = "Aggregator merchant number must contain 15 characters.";
      }
      else {
        this.raiseDanger = false;
        this.danger = "";
      }
    }

    return this.error;
  }

  public validateAggregator(): boolean {

    if (this.participant.isAggregator) {
      if (this.participant.aggregatorMerchant != null) {
        if (this.participant.aggregatorMerchant.length < 15 && this.participant.aggregatorMerchant !== '') {
          this.raiseDanger = true;
          this.danger = "Aggregator merchant number is required and must contain 15 characters.";
          return true;
        }
      }
      else {
        this.raiseDanger = true;
        this.danger = "Aggregator merchant number is required and must contain 15 characters.";
        return true;
      }

      if (this.participant.aggregatorSinkNode != null) {
        if (this.participant.aggregatorSinkNode == '') {
          this.raiseDanger = true;
          this.danger = "Aggregator sinknode is required.";
          return true;
        }
        return false;
      }
      else {
        this.raiseDanger = true;
        this.danger = "Aggregator sinknode is required.";
        return true;
      }
    }
    else {
      //clear fields.
      this.participant.aggregatorMerchant = null;
      this.participant.aggregatorSinkNode = null;
    }
    return false;
  }

  public checkConditions(value): void {
    console.log(this.participant);
  }

  public IsAggregator(value): void {
    setTimeout(() => {
      var val = value.target.checked;

      if (!val) {
        this.disableFields = "disabled :true";
        this.participant.aggregatorMerchant = null;
        this.participant.aggregatorSinkNode = null;
      }
      else {
        this.disableFields = "disabled :false";
      }

    }, 2000);
  }

  public async save(): Promise<void> {
    if (!this.canEdit) {
      this._toastService.error("You do not have the required permissions to perform this action.", "Error");
    } else {
      if (!this.participant.hasCommissionDetails && this.participant.hasBankingDetails) {
        this._toastService.warning("Commissions tab will be hidden as well.", "Warning");
        this.participant.hasCommissionDetails = true;
        if (this.validateAggregator() === false) {
          this.createResult = await this._participantService.Update(this.participant);
          if (this.createResult.success) {
            this._toastService.success(this.createResult.message, "Success");
            this.raiseDanger = false;
          } else {
            this.raiseDanger = true;
            this.danger = this.createResult.message;
          }
        }
      }
      else {
        if (this.validateAggregator() === false) {
          this.createResult = await this._participantService.Update(this.participant);
          if (this.createResult.success) {
            this._toastService.success(this.createResult.message, "Success");
            this.raiseDanger = false;
          } else {
            this.raiseDanger = true;
            this.danger = this.createResult.message;
          }
        }
      }


      this.settings = {
        id: 0,
        participantId: this.participant.id,
        type: 'SerialNumber',
        status: this.activateSerialNumber
      }
      debugger;
      await this._participantService.AddUpdateSettings(this.settings);

    }
  }

  public async runImport(): Promise<void> {

    this._ngxUiLoaderService.start();

    this.createResult = await this._participantService.Import();
    if (this.Status == null) {
      this.Status = this.createResult.message;
    }
    else
      this.Status += this.createResult.message;

    this._ngxUiLoaderService.stop();
  }

  public async runExport(): Promise<void> {

    if (this.sinkNodesUpdate.length <= 0) {
      this.raiseDanger = true;
      this.danger = "No data to export, please upload a csv";
    }
    else {
      if (this.totalCount > 2000) {
        this.raiseDanger = true;
        this.danger = "Records should not exceed 2000";
        return;
      }
      this._ngxUiLoaderService.start();
      this.raiseDanger = false;
      this.errorMessage = "";
      this.createResult = await this._participantService.Export(this.sinkNodesUpdate, this.totalCount);
      if (this.createResult.success) {
        this._toastService.success(this.createResult.message, "Success");
        this.raiseDanger = false;
      } else {
        this._toastService.error(this.createResult.message, "Error");
        this.raiseDanger = true;
        this.danger = this.createResult.message;
      }
      this._ngxUiLoaderService.stop();
    }
  }

  onFileChange(event: any) {

    const file = event.target.files[0];
    const reader = new FileReader();

    reader.onload = () => {
      const lines = (reader.result as string).split('\n');
      this.csvData = lines.map(line => line.split(';'));

      this.csvData.forEach(item => {


        item.map(line => line.split(';'))

        if (item[0] != '') {
          let row = {} as SinkNodesUpdateViewModel;
          row.merchantNumber = item[0];
          row.streetAddress = item[1];
          row.postalCode = item[2];
          this.sinkNodesUpdate.push(row);
        }
      });


    };

    reader.readAsText(file);
  }
}
